import React, { createContext, useState, useContext, useEffect } from 'react';
import api from '../api'; // Use our centralized api client

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [session, setSession] = useState(() => {
    try {
      const storedSession = localStorage.getItem('erp-session');
      return storedSession ? JSON.parse(storedSession) : null;
    } catch (e) {
      return null;
    }
  });

  // This effect will sync auth state across tabs
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'erp-session') {
        try {
          setSession(event.newValue ? JSON.parse(event.newValue) : null);
        } catch (e) {
          setSession(null);
        }
      }
    };
    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const login = (sessionData) => {
    localStorage.setItem('erp-session', JSON.stringify(sessionData));
    setSession(sessionData);
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      // Always clear local state regardless of API call success
      localStorage.removeItem('erp-session');
      setSession(null);
    }
  };
  
  const user = session?.user;
  const accessToken = session?.access_token;
  const isAuthenticated = !!session;

  const value = {
    isAuthenticated,
    user,
    accessToken,
    login,
    logout,
    session,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use the auth context
export const useAuth = () => {
  return useContext(AuthContext);
};
